<template>
  <span :class="['ui-badge', variant_class]">
    <slot />
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  variant?: 'neutral' | 'accent' | 'success' | 'info' | 'warning'
}>()

const variant_class = computed(() => {
  switch (props.variant) {
    case 'accent':
      return 'ui-badge--accent'
    case 'success':
      return 'ui-badge--success'
    case 'info':
      return 'ui-badge--info'
    case 'warning':
      return 'ui-badge--warning'
    default:
      return 'ui-badge--neutral'
  }
})
</script>

<style scoped>
.ui-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 600;
}

.ui-badge--neutral {
  background: #e2e8f0;
  color: #0f172a;
}

.ui-badge--accent {
  background: linear-gradient(135deg, var(--color-accent), var(--color-accent-hover));
  color: #fff;
}

.ui-badge--success {
  background: #dcfce7;
  color: var(--color-success-hover);
}

.ui-badge--info {
  background: #dbeafe;
  color: #1e40af;
}

.ui-badge--warning {
  background: #fef9c3;
  color: #854d0e;
}
</style>
